import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/shared/utils/cn';

export interface PageShellProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/** Standard list/detail vertical rhythm. Side inset: docs/page-gutter.md. */
export function PageShell({ children, className, ...rest }: PageShellProps) {
  return (
    <div
      className={cn('mx-auto flex min-h-full w-full flex-col gap-4', className)}
      {...rest}
    >
      {children}
    </div>
  );
}
